<div class="message-input">
  <button
    mat-icon-button
    class="message-input-file"
    (click)="fileInput.click()"
  >
    <mat-icon>attach_file</mat-icon>
  </button>
  <input
    hidden
    #fileInput
    type="file"
    (change)="handleFileSelected($event)"
  >
  <div class="message-input-field">
    <mat-form-field
      appearance="outline"
      class="message-input-form-field"
    >
      <mat-label>Введите сообщение</mat-label>
      <textarea
        matInput
        cdkTextareaAutosize
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="7"
        class="message-textarea"
        placeholder="Введите сообщение"
        [(ngModel)]="newMessage"
        (keydown.enter)="handelSendMessage()"
      ></textarea>
    </mat-form-field>
    <button
      mat-icon-button
      class="message-input-btn-send"
      (click)="handelSendMessage()"
    >
      <mat-icon>send</mat-icon>
    </button>
  </div>
</div>
